import React from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme } from '@24i/nxg-sdk-higgs/src/hooks/useTheme';
import { LandingScreenConfig } from '@24i/nxg-sdk-photon/src';
import { useAppConfigQuery } from '@24i/nxg-sdk-smartott-shared/src/hooks/query/useAppConfigQuery';

export const useRenderWhenBlocked = ({ Component }) => {
    const { isLoading, appSettings } = useAppConfigQuery();
    const { theme } = useTheme();
    const { t } = useTranslation();

    const headlineText = t('error.E04.title');
    const subtitleText = t('error.E04.body');

    const renderWhenBlocked = ({ isBlocked }) => {
        const getLandingScreenConfigFromTheme = (): LandingScreenConfig | null => {
            const {
                elements: { landingImageLandscape, landingImagePortrait },
            } = theme;

            return {
                backgroundColor: theme.color.darker1,
                ...(appSettings?.features?.landingScreen || {}),
                ...(landingImagePortrait?.value || landingImageLandscape?.value
                    ? {
                          backgroundImage: {
                              landscape: landingImageLandscape?.value?.toString() || '',
                              portrait: landingImagePortrait?.value?.toString() || '',
                          },
                      }
                    : {}),
            };
        };

        if (isBlocked) {
            const componentProps = {
                isLoading,
                landingScreenConfig: getLandingScreenConfigFromTheme() || null,
                headlineText,
                subtitleText,
            };
            return <Component {...componentProps} />;
        }

        return null;
    };

    return {
        renderWhenBlocked,
    };
};
